import { AppStoreDexieRepositoryStore } from "@/store/repositories/AppStoreDexieRepositoryStore";
import { AppSubStore, AppSubStoreArgs } from "@/store/types";
import { makeObservable } from "mobx";

export class AppStoreDexieStore extends AppSubStore {
  repositories: AppStoreDexieRepositoryStore;

  constructor(injectedDeps: AppSubStoreArgs) {
    super(injectedDeps);

    this.repositories = new AppStoreDexieRepositoryStore(injectedDeps);

    makeObservable(this, {
      repositories: true,
    });
  }
}
